import React, { useState, useEffect } from 'react';
import { array, bool } from 'prop-types';

import { connect } from 'react-redux';

import { isNil } from 'lodash';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';

import * as ServiceManagementActions from '../../../actions/serviceManagementActions';

import classes from './IssueTypeIcons.module.css';

const Icons = ({issueIds, issueTypes, onIconClick}) => {
    const issueIcons = [];

    issueIds.forEach((issueId, index) => {
        const targetIssue = issueTypes.find(issueType => issueType.id === issueId);

        if (isNil(targetIssue)) return null;

        issueIcons.push(
            <Tooltip
                title={
                    <React.Fragment>
                        <span className={classes.tooltip}>{targetIssue.label}</span>
                    </React.Fragment>
                }
                placement="top-start"
                key={index}
            >
                <img
                    src={`/assets/images/${targetIssue.icon}`}
                    alt={targetIssue.label}
                    onClick={() => onIconClick(issueId)}
                    role="none"
                    className={classes.hover}
                />
            </Tooltip>
        );
    });

    return (
        <React.Fragment>
            {issueIcons}
        </React.Fragment>
    );
};

const EditIssueTypeIcons = ({
    callIssues,
    disabled,
    issues,
    issueTypes,
    setCallIssues,
    setIssueTypes,
    showButton,
    ...props
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [missingIssueTypes, setMissingIssueTypes] = useState([]);
    const open = Boolean(anchorEl);

    useEffect(() => {
        setCallIssues(issues);
    }, [issues]);

    useEffect(() => {
        let storedIssueTypes = [];

        issueTypes.forEach(type => {
            if (!callIssues.includes(type.id)) {
                storedIssueTypes.push(type);
            }
        });

        setMissingIssueTypes(storedIssueTypes);
    }, [callIssues]);

    const handleOpen = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleAddIssue = issueType => {
        const storedIssues = [...callIssues, issueType.id];

        setCallIssues(storedIssues);

        handleClose();
    };

    const handleRemoveIssue = issue => {
        if (disabled) return;

        const storedIssues = callIssues.filter(i => i !== issue);

        setCallIssues(storedIssues);
    };

    const renderAddButton = () => {
        if (callIssues.length < issueTypes.length) {
            return (
                <React.Fragment>
                    <button
                        aria-owns={open ? 'render-props-menu' : undefined}
                        aria-haspopup="true"
                        onClick={handleOpen}
                        className={classes.addButton}
                    >+</button>
                    <Menu
                        id="render-props-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        className={classes.contextMenu}
                    >
                        {
                            missingIssueTypes.map(issueType => {
                                return (
                                    <MenuItem
                                        onClick={() => handleAddIssue(issueType)}
                                        key={issueType.id}
                                    >
                                        <img
                                            alt=""
                                            className={classes.contextIcon}
                                            src={`/assets/images/${issueType.icon}`}
                                        />
                                        {issueType.label}
                                    </MenuItem>
                                );
                            })
                        }
                    </Menu>
                </React.Fragment>
            );
        }

        return null;
    };

    return (
        <div className={classes.IssueTypeIcons}>
            <Icons
                issueIds={callIssues}
                issueTypes={issueTypes}
                onIconClick={handleRemoveIssue}
            />
            {showButton && !disabled ? renderAddButton() : null}
        </div>
    );
};

EditIssueTypeIcons.defaultProps = {
    callIssues: [],
    issues:     [],
    issueTypes: [],
    showButton: false
};

EditIssueTypeIcons.propTypes = {
    callIssues: array,
    issues:     array,
    issueTypes: array,
    showButton: bool
};

const mapStateToProps = state => {
    return {
        callIssues: state.svcManagement.callIssues,
        issueTypes: state.svcManagement.issueTypes
    };
};

const mapDispatchToProps = {
    ...ServiceManagementActions
};

export default connect(mapStateToProps, mapDispatchToProps)(EditIssueTypeIcons);
